import { ReduxUserQueue } from '~/data/store/reducer/waitingroom/usecases';

import { UserQueue as UseCaseReduxUserQueueWaitingRoom } from '~/domain/usecases/waitingRoom/redux';

/**
 * Join at conference by SocketIO.
 */
export const makeReduxUserQueueWaitingRoom =
  (): UseCaseReduxUserQueueWaitingRoom => new ReduxUserQueue();
